import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import infoStyles from '../Info.module.css';
import styles from './NotificationInfo.module.css';

function DealNotificationInfo({ dealId, name, address, className }: IDealNotificationInfoProps) {
    const navigate = useNavigate();

    return (
        <div className={[infoStyles.container, className].join(" ")} onClick={() => navigate(`/deals/${dealId}/edit`)}>
            <div className={infoStyles.title}>{name}</div>
            <div className={infoStyles.description}>
                <div>{address}</div>
                <div className={styles.red}>Needs parcel info</div>
            </div>
        </div>
    );
}

export default observer(DealNotificationInfo);

interface IDealNotificationInfoProps {
    dealId: number;
    name: string;
    address: string;
    className?: string;
}